import type { ReactNode } from "react";
import useIsMobile from "~/kernel/browser/useIsMobile";

type RenderOnDesktopProps = {
  children: ReactNode;
};

export default function RenderOnDesktop({ children }: RenderOnDesktopProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  return <>{children}</>;
}
